import { render, staticRenderFns } from "./UnpairTelegram.vue?vue&type=template&id=63d2ee3a&scoped=true"
import script from "./UnpairTelegram.vue?vue&type=script&lang=js"
export * from "./UnpairTelegram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d2ee3a",
  null
  
)

export default component.exports